module.exports = __webpack_public_path__ + "img/landing-info-one.03523297.png";